// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { EntityMultiTeamSelectInput } from 'common/entity/generic/EntityTeamSelectInput';
import useTransporterTeams from './useTransporterTeams';

import { Team } from 'common/models/internal/Team';
import { ApiStatusEnum } from 'common/enums/API';

type Props = {
    clientId: string,
    transporterId: string,
    allTeams: Array<Team>
};

const TransporterTeams = ({
    clientId,
    transporterId,
    allTeams
}: Props): React.Node => {
    const teamsQuery = useTransporterTeams({ clientId, transporterId });
    const { t } = useTranslation();

    return (
        <EntityMultiTeamSelectInput
            label={t('entities:team_plural')}
            teams={teamsQuery.data || []}
            allTeams={allTeams}
            isLoading={teamsQuery.status === ApiStatusEnum.Loading}
            disabled
        />
    );
};

export default TransporterTeams;
